import { useMutation, useQueryClient } from 'react-query';

import { useAuth0 } from '@auth0/auth0-react';
import setToken from '../../utils/api';

import { IApiResponse } from '../../types/IApiResponse';

export default function useCreateOrder() {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<IApiResponse<any>, IApiResponse<any>, any>(
    ['create-order'],
    async ({ ...data }: any) => {
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.post<IApiResponse<any>>('api/orders', data);

      if (response.status !== 201) {
        throw new Error(
          response.data?.Message ?? response.data?.message ?? 'Request failed',
        );
      }

      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('order-list');
        queryClient.invalidateQueries('order-count');
      },
    },
  );
}
